/**
 * Canonical product-page URL (P3-01). Flat `/products/[slug]` — slugs are
 * unique per brand (`@@unique([brandId, slug])`), so a slug resolves to
 * exactly one product for the active tenant. Cards, upsells, and canonical
 * metadata all route through here.
 */
export const PRODUCTS_ROUTE_BASE = "/products";

export function productHref(slug: string, variantId?: string): string {
  const base = `${PRODUCTS_ROUTE_BASE}/${slug}`;
  return variantId ? `${base}?variant=${encodeURIComponent(variantId)}` : base;
}

/**
 * P15-18 · The shop-all listing — the catalogue's own landing page, and the
 * root of the namespace every PDP hangs under.
 *
 * A function rather than the bare constant for the same reason `blogIndexHref`
 * is one: `SEO_ENTITY_TYPES.productIndex.pathOf` calls it, so the canonical,
 * the sitemap entry, the breadcrumb and the link a shopper clicks all come
 * from here.
 */
export function productsIndexHref(): string {
  return PRODUCTS_ROUTE_BASE;
}
